/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input } from "@angular/core";
import { AbstractModalComponent } from "../abstract-modal.component";

@Component({
   standalone: false,
   selector: "cancel-confirm-dialog",
   templateUrl: "./cancel-confirm-dialog.component.html",
   styles: [
      `
         /deep/ .modal.show .modal-dialog {
            width: 451.89px;
         }
      `
   ]
})
export class CancelConfirmDialogComponent extends AbstractModalComponent {
   @Input() public title;
   @Input() public message;
   @Input() public showWarning;
   @Input() public isTransferringFile;
   @Input() public buttonLabelConfirm?;
   @Input() public buttonLabelCancel?;
}
